import * as React from "react";
import { AbstractDocumentKind } from "../model/autogen/AbstractDocumentKind";
import { Content } from "./content";
import { ContentTypePicker } from "./content-type-picker";

export interface IContentTypeContainerElementProps {
    contentType: AbstractDocumentKind;
    render: (ct: AbstractDocumentKind) => JSX.Element;
    renderForUnselected: () => JSX.Element;
}

export const ContentTypeContainerElement = (props: IContentTypeContainerElementProps) => {
    switch(props.contentType) {
        case AbstractDocumentKind.FAQ:
        case AbstractDocumentKind.IssueBrief:
        case AbstractDocumentKind.ProfileOfMP:
        case AbstractDocumentKind.DebateNotes:
        case AbstractDocumentKind.MediaLines:
        case AbstractDocumentKind.OpinionEditorial:
        case AbstractDocumentKind.Person:
        case AbstractDocumentKind.Quote:
        case AbstractDocumentKind.Achievement:
        case AbstractDocumentKind.Resource:
            return props.render(props.contentType);
        default:
            return props.renderForUnselected();
    }
}

export interface IContentTypeContainerProps {
    renderForSelected: (ct: AbstractDocumentKind) => JSX.Element;
    renderForUnselected: () => JSX.Element;
}

export class ContentTypeContainer extends React.Component<IContentTypeContainerProps, any> {
    constructor(props: IContentTypeContainerProps) {
        super(props);
        this.state = {
            contentType: ""
        }
    }
    private onContentTypeChanged = (ct: AbstractDocumentKind) => {
        this.setState({ contentType: ct });
    }
    public render(): JSX.Element {
        const { renderForSelected, renderForUnselected } = this.props;
        const { contentType } = this.state;
        return <>
            <Content>
                <ContentTypePicker dataEntry label="Select Content Type" name="contentType" contentType={contentType} onChange={this.onContentTypeChanged} />
            </Content>
            <Content>
                <ContentTypeContainerElement contentType={contentType} render={renderForSelected} renderForUnselected={renderForUnselected} />
            </Content>
        </>;
    }   
}


// WEBPACK FOOTER //
// ./src/components/content-type-container.tsx